import axios from 'axios'

const getDefaultState = () => ({
  templates: [],
});

const state = getDefaultState();

const getters = {
  getTemplates: (state) => state.templates,
}

const actions = {
  async listTemplates({ commit, rootState }) {
    axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;
    const config = {
      headers: {
        Authorization: rootState.auth.bearer
      }
    };
    const response = await axios.get('/v2/email-templates', config);
    commit('SET_TEMPLATES', response.data.templates || []);
    return response.data.templates || [];
  },

  async createTemplate({ dispatch, rootState }, payload) {
    axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;
    const config = {
      headers: {
        Authorization: rootState.auth.bearer
      }
    };
    try {
      await axios.post('/v2/email-templates', payload, config);
      await dispatch('listTemplates');
      dispatch('notifications/addNotification', { type: 'success', message: 'Email template created' }, { root: true });
    }
    catch (error) {
      const message = error.response?.data?.message || 'Failed to create email template';
      dispatch('notifications/addNotification', { type: 'error', message }, { root: true });
      throw error;
    }
  },

  async updateTemplate({ dispatch, rootState }, { id, ...payload }) {
    axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;
    const config = {
      headers: {
        Authorization: rootState.auth.bearer
      }
    };
    try {
      await axios.put(`/v2/email-templates/${id}`, payload, config);
      await dispatch('listTemplates');
      dispatch('notifications/addNotification', { type: 'success', message: 'Email template updated' }, { root: true });
    }
    catch (error) {
      const message = error.response?.data?.message || 'Failed to update email template';
      dispatch('notifications/addNotification', { type: 'error', message }, { root: true });
      throw error;
    }
  },

  async deleteTemplate({ dispatch, rootState }, id) {
    axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;
    const config = {
      headers: {
        Authorization: rootState.auth.bearer
      }
    };
    try {
      await axios.delete(`/v2/email-templates/${id}`, config);
      await dispatch('listTemplates');
      dispatch('notifications/addNotification', { type: 'success', message: 'Email template deleted' }, { root: true });
    }
    catch (error) {
      const message = error.response?.data?.message || 'Failed to delete email template';
      dispatch('notifications/addNotification', { type: 'error', message }, { root: true });
      throw error;
    }
  },

  async previewTemplateContent({ dispatch, rootState }, { content, type }) {
    axios.defaults.baseURL = rootState.tenant.tenantinfo.baseAPI;
    const config = {
      headers: {
        Authorization: rootState.auth.bearer
      }
    };
    try {
      const response = await axios.post('/v2/email-templates/preview', { Content: content, Type: type }, config);
      return response.data.emailHtml;
    }
    catch (error) {
      const message = error.response?.data?.message || 'Failed to load preview';
      dispatch('notifications/addNotification', { type: 'error', message }, { root: true });
      throw error;
    }
  },

  resetState({ commit }) {
    commit('RESET_STATE')
  },
}

const mutations = {
  SET_TEMPLATES(state, templates) {
    state.templates = templates
  },
  RESET_STATE(state) {
    Object.assign(state, getDefaultState())
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
